import { render, staticRenderFns } from "./HostedZones.vue?vue&type=template&id=3b5ed192&"
import script from "./HostedZones.vue?vue&type=script&lang=js&"
export * from "./HostedZones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports